module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_03_beach-photo-2983ab574150784ab8cdf7d3242069b7.jpg";